import { ApiError } from "@/shared/types";

export const validateLogin = (data: any): ApiError | undefined => {
  const errors: ApiError = {};

  if (!data.email) {
    errors.email = "Email is required";
  }
  if (!data.password) {
    errors.password = "Password is required";
  }

  return Object.keys(errors).length ? errors : undefined;
};
